export default __webpack_public_path__ + "static/media/Black Dragon Tongue.9696258e.jpg";